import React, { useState } from 'react';
import Sidebar from '../../partials/Sidebar';
import Header from '../../partials/Header';
import DashboardCard26otherviwe from '../../partials/dashboard/DashboardCard26otherviwe';

function ViweOtheractivity() {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="flex h-screen overflow-hidden">
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className="relative flex flex-col flex-1 overflow-y-auto ">
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main className="grow">
                    <div className="px-4 sm:px-6 lg:px-8 py-8 xs:pb-10 w-full max-w-9xl mx-auto">
                        <div className="sm:flex sm:justify-between sm:items-center mb-8">
                            <div className="mb-4 sm:mb-0">
                                <h1 className="text-2xl md:text-3xl  xs:pb-10 text-gray-800 dark:text-gray-100 font-bold">Vizualizeaza alte activitati</h1>
                            </div>
                        </div>
                        <DashboardCard26otherviwe />
                    </div>
                </main>
            </div>
        </div>
    );
}

export default ViweOtheractivity;